export enum UserGroupType {
    Admin = 'ADMIN',
    Default = 'DEFAULT',
    External = 'EXTERNAL',
}

export enum DisplayUserName {
    FirstLast = 'firstLast',
    LastFirst = 'lastFirst',
    Other = 'other',
}
